import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import PlainTitleText from "@/components/plainTitleText/PlainTitleText.vue";
import SingleVideo from "@/components/singleVideo/SingleVideo.vue";

export default {
  name: "VideoGrid",
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    videos: { type: Array }
  },
  data() {
    return {
        carouselSettings: {
            arrows: false,
            dots: true,
            adaptiveHeight: true,
            slidesToShow: 2,
            rows: 2,
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    rows: 1,
                    slidesToScroll: 1
                  }
                }
            ]
        }
    }
  },
  created: function () {
    $(document).ready(function(){
      $(".close_overlay").on("click", function(element) {
        $("#video-playing-overlay").removeClass("d-block");
        $("body").removeClass("overflow-hidden");
        $("#video-playing-overlay .player").find("iframe").remove()
      });
    });
  },
  components: {
    VueSlickCarousel,
    PlainTitleText,
    SingleVideo
  },
  methods: {
    playVideo(url) {
      $("#video-playing-overlay").addClass("d-block");
      $("body").addClass("overflow-hidden");
      $("#video-playing-overlay .player").append(
        $("<iframe />", {
          title: "YouTube video player",
          frameborder: "0",
          controls: "0",
          src: url + "?controls=2&frameborder=0&fs=0&modestbranding=1&rel=0"
        })
      )
    }
  }

};
